export default {
  disclaimers:{
    aggreen:'我已阅读并同意',
    aggereen_title:'免责声明',
    title:'免责声明',
    nav_title:'投资者在使用本交易系统前，请仔细阅读以下免责声明:',
    t0:'如果客户透过电子服务进行买卖，客户便须承受该电子服务系统带来的风险，包括有关系统硬件和软件可能会失灵的风险。系统失灵可能会导致客户的买卖盘不能根据指示执行，甚或完全不获执行;',
    t1:'由于未可预计的网络挤塞和其他原因，电子服务可能并不可靠的，及存在通过电子服务进行的交易在传输和接收客户的指示或其他信息过程中可能会被耽误、延迟执行客户的指示或有关指示以有别于客户发出指示时的市价执行、指示在传输时被中断或停顿等风险。',
    t2:'在通信过程中也存在误解或错误的风险，以及在发出了指示后，通常也不一定可以取消。由于此类中断、耽误或被第三方进入而使客户遭受的任何损失，本公司概不承担责任。如果客户不准备接受此类中断或耽误引致的风险，客户不应透过电子服务作出任何指示;',
    t3:'通过电子服务向客户提供的市场数据和其他信息可能是本公司从第三者获得的。虽然本公司相信这些数据和信息是可靠的，但本公司或该等第三者都不会保证这些数据和信息的准确性、完整性和即时性。',
    t4:'客户应自行对交易决策和操作负责，不得归咎于本交易系统。客户应遵守相关法律法规和交易所规则，对自身行为承担全部责任。',
    t5:'本交易系统提供的所有信息和分析仅供参考，不构成任何投资建议。客户应独立做出投资决策，自行承担相应的交易风险。'
  }
}
